import styled from 'styled-components';
import { colors, breakpoints } from '../../../assets/styles/GlobalStyles';

export const CardOverlay = styled.div`
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  overscroll-behavior: contain;
  animation: fadeIn 0.2s ease-out;
  
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const SupportCardContainer = styled.div`
  position: relative;
  background: ${colors.white};
  border-radius: 5px;
  width: 90%;
  max-width: 520px;
  // dvh acompanha a barra do navegador no celular; vh fica de fallback
  max-height: calc(100vh - 2rem);
  max-height: calc(100dvh - 2rem);
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.35);
  animation: slideUp 0.3s ease-out;
  
  @keyframes slideUp {
    from {
      transform: translateY(30px) scale(0.96);
      opacity: 0;
    }
    to {
      transform: translateY(0) scale(1);
      opacity: 1;
    }
  }

  @media (max-width: ${breakpoints.small}) {
    width: 95%;
    border-radius: 24px;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, ${colors.darkBlue} 0%, ${colors.blueMedium} 100%);
  border-radius: 5px 5px 0 0;
  flex-shrink: 0;

  @media (max-width: 480px) {
    padding: 1rem 1.25rem;
    border-radius: 24px 24px 0 0;
  }
`;

export const CardTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  
  svg {
    font-size: 24px;
    color: ${colors.white};
  }
  
  h2 {
    font-size: 1.25rem;
    color: ${colors.white};
    margin: 0;
    font-weight: 600;
    
    @media (max-width: 480px) {
      font-size: 1.1rem;
    }
  }
`;

export const CloseButton = styled.button`
  background: rgba(255, 255, 255, 0.15);
  border: none;
  cursor: pointer;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  color: ${colors.white};
  
  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.05);
  }
  
  svg {
    font-size: 18px;
  }
`;

export const CardBody = styled.div`
  padding: 1.5rem;
  overflow-y: auto;
  flex: 1;
  
  &::-webkit-scrollbar {
    width: 5px;
  }
  
  &::-webkit-scrollbar-track {
    background: ${colors.borderLight};
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${colors.lightBlue};
    border-radius: 10px;
  }

  @media (max-width: 480px) {
    padding: 1.25rem;
  }
`;

export const ContactSection = styled.div`
  margin-bottom: 1.5rem;
  
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid ${colors.borderLight};
  
  svg {
    font-size: 18px;
    color: ${props => props.color || colors.darkBlue};
  }
  
  h3 {
    font-size: 1rem;
    font-weight: 600;
    color: ${colors.darkBlue};
    margin: 0;
  }
`;

export const ContactList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const ContactItem = styled.div`
  background: ${colors.backgroundLight};
  border-radius: 16px;
  padding: 1rem;
  transition: all 0.2s ease;
  border: 1px solid ${colors.borderLight};

  &:hover {
    background: white;
    border-color: ${colors.lightBlue};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }
`;

export const ContactDescription = styled.p`
  font-size: 0.7rem;
  color: ${colors.textMuted};
  margin: 0 0 8px 0;
  line-height: 1.3;
`;

export const PhoneNumberWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: ${props => props.$hasButton ? '12px' : '0'};
  
  span {
    font-size: 1rem;
    font-weight: 700;
    color: ${colors.darkBlue};
    letter-spacing: -0.2px;
    font-family: 'Inter', monospace;
  }
`;

export const CopyButton = styled.button`
  background: transparent;
  border: 1px solid ${colors.borderLight};
  color: ${colors.lightBlue};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.7rem;
  font-weight: 500;
  padding: 4px 12px;
  min-height: 32px;
  border-radius: 20px;
  transition: all 0.2s ease;
  
  &:hover {
    background: ${colors.backgroundLight};
    border-color: ${colors.lightBlue};
    transform: scale(1.02);
  }
  
  svg {
    font-size: 10px;
  }
`;

export const WhatsAppButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  color: white;
  border: none;
  border-radius: 14px;
  text-decoration: none;
  font-size: 0.85rem;
  font-weight: 600;
  transition: all 0.2s ease;
  cursor: pointer;
  margin-top: 8px;
  box-sizing: border-box;
  
  svg {
    font-size: 16px;
    flex-shrink: 0;
  }
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);
  }
`;

export const HorarioCard = styled.div`
  background: ${colors.backgroundLight};
  border-radius: 16px;
  padding: 1rem;
  margin: 1rem 0 0.75rem 0;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid ${colors.borderLight};
  
  svg {
    font-size: 20px;
    color: ${colors.darkBlue};
  }
`;

export const HorarioContent = styled.div`
  flex: 1;
  
  strong {
    display: block;
    font-size: 0.8rem;
    color: ${colors.darkBlue};
    margin-bottom: 2px;
  }
  
  p {
    font-size: 0.75rem;
    color: ${colors.textMuted};
    margin: 0;
    line-height: 1.3;
  }
`;